import { createSelector } from '@reduxjs/toolkit';

function recursiveFindObj(list, id, objType = 'file') {
  let file = list.find((i) => i.id === id && i.objType === objType);
  if (file) {
    return file;
  }
  for (const item of list) {
    file = recursiveFindObj(item.children || [], id, objType);
    if (file) {
      return file;
    }
  }
}

const getScriptFile = (state, props) => {
  if (!props.fileId) return {};
  const { content } = state.scriptContent;
  return recursiveFindObj(content.children, props.fileId, props.objType) || {};
};

export const makeGetScriptFile = createSelector(
  [getScriptFile],
  (template) => template
);
